import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { getAllPurchase, getAllPurchaseP } from "../../actions/purchase";
import RenderTable from "./RenderTable";
import { Layout, Breadcrumb, Row, Col, Skeleton, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Search } = Input;

const ProductDetails = ({ getAllPurchase, getAllPurchaseP }) => {
  const [details, setdetails] = useState([]);
  const pageno = useRef(1);
  const page_size = useRef(10);
  const [reload, setreload] = useState(false);
  const [update, setUpdate] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    fetchData();
  }, [reload, searchKeyword]);

  const fetchData = () => {
    const params = {
      page: pageno.current,
      page_size: page_size.current,
    };
    
    if (searchKeyword) {
      params.keyward = searchKeyword;
    }

    getAllPurchaseP(params.page, params.page_size, params.keyward).then(function (result) {
      setdetails(result);
      setUpdate(true);
    });
  };

  const handleSearch = (value) => {
    setSearchKeyword(value);
    pageno.current = 1; 
    setreload(!reload);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      setSearchKeyword("");
      pageno.current = 1;
      setreload(!reload);
    }
  };

  const rendertable = () => {
    if (update) {
      return (
        <RenderTable
          details={details}
          pageno={pageno}
          page_size={page_size}
          setreload={setreload}
          reload={reload}
          setUpdate={setUpdate}
        />
      );
    } else {
      return <Skeleton active />;
    }
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Purchase Order</Breadcrumb.Item>
        <Breadcrumb.Item>All</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Row style={{ marginBottom: 16 }}>
          <Col span={8}>
            <Search
              placeholder="Search by purchase number "
              allowClear
              enterButton={<SearchOutlined />}
              size="middle"
              onSearch={handleSearch}
              onChange={handleSearchChange}
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
        {rendertable()}
      </div>
    </>
  );
};

export default connect(null, { getAllPurchase, getAllPurchaseP })(
  ProductDetails
);